import { createFileRoute } from '@tanstack/react-router';
import { AccountLayout } from '@uturn/portal/modules/account/layout';

export const Route = createFileRoute('/_protected/account')({
	component: AccountLayout,
});
